module.exports = __webpack_public_path__ + "img/clients3-1680.2807e2c.png";